import {
  CREATE_ADDRESS_FAILURE,
  CREATE_ADDRESS_REQUEST,
  DELETE_ADDRESS_REQUEST,
  DELETE_ADDRESS_FAILURE,
  UPDATE_ADDRESS_REQUEST,
  UPDATE_ADDRESS_FAILURE,
  UPDATE_BILLING_ADDRESS_REQUEST,
  UPDATE_BILLING_ADDRESS_FAILURE,
  GET_ADDRESS_REQUEST,
  GET_ADDRESS_SUCCESS,
  GET_ADDRESS_FAILURE,
  CREATE_ADDRESS_SUCCESS,
  DELETE_ADDRESS_SUCCESS,
  UPDATE_ADDRESS_SUCCESS,
  UPDATE_BILLING_ADDRESS_SUCCESS,
  GET_VALIDATE_ADDRESS_SUCCESS,
  GET_VALIDATE_ADDRESS_FAILURE,
  GET_VALIDATE_ADDRESS_REQUEST,
  GET_ACTIVE_ADDRESS_REQUEST,
  GET_ACTIVE_ADDRESS_SUCCESS,
  GET_ACTIVE_ADDRESS_FAILURE,
} from "./ActionType";

const initialState = {
  address: null,
  loading: false,
  actionLoading: false,
  error: "",
  addresses: [],
};

export const addressReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_ADDRESS_REQUEST:
      return { ...state, actionLoading: true };

    case CREATE_ADDRESS_SUCCESS:
      return { ...state, actionLoading: false, error: "", createAddress: action.payload };

    case CREATE_ADDRESS_FAILURE:
      return { ...state, actionLoading: false, error: action.payload };

    case GET_ADDRESS_REQUEST:
    case GET_VALIDATE_ADDRESS_REQUEST:
      return { ...state, loading: true };

    case GET_ADDRESS_SUCCESS:
    case GET_VALIDATE_ADDRESS_SUCCESS:
      return { ...state, loading: false, error: "", address: action.payload };

    case GET_ADDRESS_FAILURE:
    case GET_VALIDATE_ADDRESS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case GET_ACTIVE_ADDRESS_REQUEST:
      return { ...state, loading: true };

    case GET_ACTIVE_ADDRESS_SUCCESS:
      return { ...state, loading: false, error: "", addresses: action.payload };

    case GET_ACTIVE_ADDRESS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case DELETE_ADDRESS_REQUEST:
      return { ...state, loading: true };

    case DELETE_ADDRESS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
        addresses: state.addresses.filter(address => address.id !== action.payload), // remove from list
      };

    case DELETE_ADDRESS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case UPDATE_ADDRESS_REQUEST:
      return { ...state, actionLoading: true };

    case UPDATE_ADDRESS_SUCCESS:
      return { ...state, actionLoading: false, error: "", updateAddress: action.payload };

    case UPDATE_ADDRESS_FAILURE:
      return { ...state, actionLoading: false, error: action.payload };

    case UPDATE_BILLING_ADDRESS_REQUEST:
      return { ...state, actionLoading: true };

    case UPDATE_BILLING_ADDRESS_SUCCESS:
      return { ...state, actionLoading: false, error: "", updateBiilingAddress: action.payload };

    case UPDATE_BILLING_ADDRESS_FAILURE:
      return { ...state, actionLoading: false, error: action.payload };

    default:
      return state;
  }
};
